import { gameApi } from '@/helpers/api'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

export const useGameMaintenanceStore = defineStore('gameMaintenance', () => {
  const isMaintenance = ref(false)
  const route = useRoute()

  async function fetch() {
    const {
      data: { maintenance },
    } = await gameApi.get('maintenance/10100')

    if (import.meta.env.VITE_APP_ENV !== 'live') {
      if (route.query.isMaintenance) {
        isMaintenance.value = route.query.isMaintenance.toString().toLowerCase() === 'true'
        return
      }
    }
    isMaintenance.value = maintenance
  }
  return {
    isMaintenance,
    fetch,
  }
})
